import worksiteApi from '../../api/worksite'
import collectionsApi from '@/api/collections'
import locationApi from '../../api/location'
import employeeApi from '../../api/employee'
import shiftApi from '../../api/shift'

// initial state
const state = {
  possibleLocations: [],
  possiblePositions: [],
  assignableEmployees: [],
  newRequestPreferences: [],
}

// getters
const getters = {
}

// actions
const actions = {
  getOptions ({ commit }, userId) {
    collectionsApi.getLocations(worksites => {
      commit('setPossibleLocations', worksites)
    })
    employeeApi.getPrimaryPositions(null, positions => {
      commit('setPossiblePositions', positions)
    })
    collectionsApi.getEmployees(employees => {
      commit('setAssignableEmployees', employees)
    })
  },

  getRequestPreferences({ commit }, locationID) {
    return new Promise((resolve, reject) => {
      shiftApi.getNewRequestPreferences(locationID, prefs => {
        commit('setNewRequestPreferences', prefs)
        resolve(prefs)
      })
    })
  },

  getSkills ({ commit }) {
    return new Promise((resolve, reject) => {
      collectionsApi.getSkills(skills => {
        resolve(skills)
      },
      error => {
        reject(error)
      })
    })
  },

  getWorksiteNamesAndIds ({ commit }, userId) {
    worksiteApi.getNamesAndIds(userId, worksites => {
      commit('setPossiblePositions', worksites)
    })
  },

  // getEmployeesAt ({ dispatch, commit }, locationId) {
  //   return new Promise((resolve, reject) => {
  //     locationApi.getEmployees(locationId, employees => {
  //       commit('setAssignableEmployees', employees)
  //       resolve()
  //     },
  //     error => {
  //       console.log("couldn't get employees")
  //       reject()
  //     })
  //   })
  // },

  create ({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      shiftApi.create(params, shift => {
         const message = `Shift created!`
         dispatch('global/showSnackbarSuccess', { message: message }, { root: true })
         resolve(shift)
      },
      error => {
         const message = `Something went wrong creating that shift...`
         dispatch('global/showSnackbarError', { message: message }, { root: true })
         reject()
      })
    })
  },

  bulkCreate ({ dispatch, commit }, shiftParams) {
    return new Promise((resolve, reject) => {
      shiftApi.bulkCreate(shiftParams, shifts => {
         const message = `Shift created!`
         dispatch('global/showSnackbarSuccess', { message: message }, { root: true })
         resolve(shifts)
      },
      error => {
         const message = `Something went wrong creating that shift...`
         dispatch('global/showSnackbarError', { message: message }, { root: true })
         reject()
      })
    })
  },

  pickUp ({ dispatch, commit }, params) {
    // return new Promise((resolve, reject) => {
    //   shiftApi.pickUp(params, shift => {
    //     const message = `You've picked up the ${ shift.location } ${ shift.shiftRole } shift!`
    //     dispatch('global/showSnackbarSuccess', { message: message }, { root: true })
    //     commit('updateShift', shift)
    //     resolve()
    //   },
    //   error => {
    //     const message = `Something went wrong picking up that shift...`
    //     dispatch('global/showSnackbarError', { message: message }, { root: true })
    //     reject()
    //   })
    // })
  },

}

// mutations
const mutations = {
  setPossibleLocations (state, worksites) {
    state.possibleLocations = worksites
  },
  setPossiblePositions (state, positions) {
    state.possiblePositions = positions
  },
  setAssignableEmployees (state, employees) {
    state.assignableEmployees = employees
  },
  setNewRequestPreferences (state, prefs) {
    state.newRequestPreferences = prefs
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
